/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import { BiUser } from 'react-icons/bi';


const MultipleEmployeeApproval = ({ data }: any) => {

	return (
		<div>
			<form method="post">
				<div className="main-post-card-container">
					{data?.map((item: any, i: any) => (
						<div key={i} className='main-post-card'>
							<div className="row">
								<div className="col-md-4">
									<div className="profile-img">
										<BiUser size={80} />
									</div>
								</div>
								<div className="col-md-6">
									<div className="profile-head">
										<h5>
											{item?.title} {item?.firstName} {item?.LastName}
										</h5>
										<h6>

											<button className="view-job-profile"  >
												{item?.applicationStatus}
											</button>

										</h6>
										<h6>
											{item?.employment_type}
										</h6>
										<ul className="nav nav-tabs" id="myTab" role="tablist">
											<li className="nav-item">
												<a id="profile-tab "> <h5>Details</h5> </a>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-md-4">
									<div className="profile-work">
										<div className='profile-work-flex'>
											<p>Title:</p>
											<a>{!item?.title ? "n/a" : item?.title}</a>
										</div>
										<br />
										<div className='profile-work-flex'>
											<p>Created At</p>
											<a  >{moment(item?.createdAt).format("DD-MM-YYYY")}</a>
										</div>
									</div>
								</div>
								<div className="col-md-8">
									<div className=" " >
										<div className="tab-pane"  >
											<div className="row">
												<div className="col-md-6">
													<label>Email</label>
												</div>
												<div className="col-md-6">
													<p>{item?.email}</p>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<label>Phone</label>
												</div>
												<div className="col-md-6">
													<p>{item?.phoneNumber}</p>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<label>Location</label>
												</div>
												<div className="col-md-6">
													<p>{!item?.location ? "n/a" : item?.location}</p>
												</div>
											</div>
										</div>
										<div  >
											<div className="row">
												<div className="col-md-6">
													<label>Current Salary</label>
												</div>
												<div className="col-md-6">
													<p>{!item?.currentSalary ? "n/a" : item?.currentSalary}</p>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<label>Currency</label>
												</div>
												<div className="col-md-6">
													<p>{!item?.currency ? "n/a" : item?.currency}</p>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<label>Total Work Experience</label>
												</div>
												<div className="col-md-6">
													<p>{item?.totalWorkExperience}</p>
												</div>
											</div>
											<div className="row m-b-1">
												<div className="col-md-6">
													<label>Total Work Experience</label>
												</div>
												<div className="col-md-6">
													<p>{item?.totalWorkExperience}</p>
												</div>
											</div>
											<div className="row">
												<div className="col-md-6">
													<label>Notice Period</label>
												</div>
												<div className="col-md-6">
													<p>{item?.noticePeriod}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>))}
				</div>
			</form>

		</div>
	)
}

export default MultipleEmployeeApproval

